import { pgEnum, pgTable, timestamp, uuid, varchar } from "drizzle-orm/pg-core"
import { contacts } from "./contact"
import { estates } from "./estate"

// Enums

// Purpose: Defines external directory services that can be integrated.
export const directoryServicesEnum = pgEnum("directory_services", [
  "ACCIDENT_INSURANCE",
  "BOOK_KEEPING",
  "CANADIAN_TRUSTS",
  "CORPORATE_LAW",
  "CORPORATE_WILL",
  "ESTATE_LITIGATION",
  "ESTATE_PLANNING",
  "FINANCIAL_PLANNING",
  "FINANCIAL_STRATEGY",
  "HEALTH_DIRECTIVE",
  "HEALTH_INSURANCE",
  "INSURANCE_STRATEGY",
  "INVESTMENT_MANAGEMENT",
  "LIFE_INSURANCE",
  "OFFSHORE_TRUSTS",
  "OTHER",
  "RETIREMENT_PLANNING",
  "SICKNESS_INSURANCE",
  "TAX_FILING",
  "TAX_PLANNING",
  "TAX_PREPARATION",
  "TAX_STRATEGY",
  "US_TRUSTS",
  "WILLS",
])

// Purpose: Defines categories for directories.
export const directoryTypesEnum = pgEnum("directory_types", [
  "CPA",
  "ESTATE_ATTORNEY",
  "INSURANCE_AGENT_BROKER",
  "INVESTMENT_ADVISOR_FIDUCIARY",
  "INVESTMENT_BROKER",
  "TAX_ATTORNEY",
])

// Purpose: Organises digital directories or folders within the application, linked to estates.
export const directories = pgTable("directory", {
  id: uuid("id").primaryKey().defaultRandom(),
  estateId: uuid("estate_id")
    .notNull()
    .references(() => estates.id, { onDelete: "cascade" }),
  directoryContactId: uuid("directory_contact_id").references(() => contacts.id, {
    onDelete: "set null",
  }),
  directoryType: directoryTypesEnum("directory_type").notNull(),
  directoryService: directoryServicesEnum("directory_service"),
  name: varchar("name", { length: 255 }).notNull(),
  url: varchar("url", { length: 512 }),
  createdAt: timestamp("created_at").defaultNow().notNull(),
  updatedAt: timestamp("updated_at").defaultNow().notNull(),
})
